import { Auth0ProviderOptions, Auth0Provider } from '@auth0/auth0-react';
import { useHistory } from 'react-router-dom';
import { restorePath } from '../redirect';

export const Auth0ProviderWithRedirect: React.FC<Auth0ProviderOptions> = (
  props
) => {
  const history = useHistory();
  return (
    <Auth0Provider
      {...props}
      onRedirectCallback={(appState) => {
        if (appState) {
          const path = restorePath(appState);
          if (path) history.replace(path);
        }
      }}
    />
  );
};
